"use client";

import { c as _c } from "react/compiler-runtime";
import { cx } from "@/lib/tailwind-utils";
import { PriceDisclaimer } from "./price-disclaimer";
import { ServicesGrid } from "./services-grid";
import { useServicesView } from "./use-services-view";
export const FlatServicesView = t0 => {
  const $ = _c(27);
  const {
    className,
    onOpenDetails,
    onRequireMfa,
    onPhoneOnlyService,
    onOpenSelectionsDrawer
  } = t0;
  let t1;
  if ($[0] !== onOpenDetails || $[1] !== onOpenSelectionsDrawer || $[2] !== onPhoneOnlyService || $[3] !== onRequireMfa) {
    t1 = {
      onOpenDetails,
      onRequireMfa,
      onPhoneOnlyService,
      onOpenSelectionsDrawer
    };
    $[0] = onOpenDetails;
    $[1] = onOpenSelectionsDrawer;
    $[2] = onPhoneOnlyService;
    $[3] = onRequireMfa;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    frontPageData,
    filteredServices,
    isLoading,
    selectedCategory,
    isServiceSelected,
    getServiceInstanceCount,
    isServiceUnavailable,
    selectedServiceIds,
    canSelectMore,
    effectiveNumAllowedServices,
    handleServiceClick,
    handleQuantityChange,
    handleInfoClick
  } = useServicesView(t1);
  if (!frontPageData || isLoading) {
    return null;
  }
  let t2;
  if ($[5] !== className) {
    t2 = cx(className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== filteredServices) {
    t3 = filteredServices ?? [];
    $[7] = filteredServices;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = selectedCategory ?? "";
  let t5;
  if ($[9] !== canSelectMore || $[10] !== effectiveNumAllowedServices || $[11] !== getServiceInstanceCount || $[12] !== handleInfoClick || $[13] !== handleQuantityChange || $[14] !== handleServiceClick || $[15] !== isServiceSelected || $[16] !== isServiceUnavailable || $[17] !== selectedServiceIds.length || $[18] !== t3 || $[19] !== t4) {
    t5 = <ServicesGrid services={t3} selectedCategory={t4} isServiceSelected={isServiceSelected} getServiceInstanceCount={getServiceInstanceCount} isServiceUnavailable={isServiceUnavailable} canSelectMore={canSelectMore} selectedCount={selectedServiceIds.length} maxQuantity={effectiveNumAllowedServices} onServiceClick={handleServiceClick} onQuantityChange={handleQuantityChange} onInfoClick={handleInfoClick} />;
    $[9] = canSelectMore;
    $[10] = effectiveNumAllowedServices;
    $[11] = getServiceInstanceCount;
    $[12] = handleInfoClick;
    $[13] = handleQuantityChange;
    $[14] = handleServiceClick;
    $[15] = isServiceSelected;
    $[16] = isServiceUnavailable;
    $[17] = selectedServiceIds.length;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== filteredServices) {
    t6 = filteredServices?.some(_temp) && <PriceDisclaimer className="mt-0 text-left" />;
    $[21] = filteredServices;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== t2 || $[24] !== t5 || $[25] !== t6) {
    t7 = <div className={t2}>{t5}{t6}</div>;
    $[23] = t2;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
};
export default FlatServicesView;
function _temp(service) {
  return service.estimated;
}